import { NgClass, NgStyle } from '@angular/common';
import { Component, input, OnChanges } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import moment from 'moment';

@Component({
  selector: 'rc-sequence-preview',
  templateUrl: './sequence-preview.component.html',
  styleUrls: ['./sequence-preview.component.scss'],
  imports: [NgStyle, NgClass, MatTooltip],
})
export class SequencePreviewComponent implements OnChanges {
  fixRate = input<number>();
  duration = input<number>();
  offset = input<number>();
  periodLength = input<number>();
  startDate = input<string>();
  skipPosition = input<number>();
  isCommunication = input<boolean>();
  isBeacon = input<boolean>();

  fixPerTransmission = input<number>();
  fixes: number[] = [];
  titles: string[] = [];
  offsetSegments: { left: number; width: number }[] = [];

  ngOnChanges() {
    this.fixes = [];
    const periodLength = this.periodLength();
    if (this.fixRate() && periodLength) {
      let fix = this.offset();
      const end = this.offset() + this.duration();
      while (fix < end) {
        this.fixes.push(fix % periodLength);
        fix += this.fixRate() / 60;
      }
    }
    this.offsetSegments = this.buildOffsetSegments();
    if (this.periodLength() === 10080) {
      const startDay = moment(this.startDate()).day();
      const weekdays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
      this.titles = weekdays.map((v, i) => {
        const index = (startDay + i + 6) % 7;
        return weekdays[index];
      });
    } else {
      const length = Math.round(this.periodLength() / 60);
      const skipped = Math.floor(length / 24);
      if (skipped > 1) {
        this.titles = Array.from({ length: 24 }, (v, i) => (i * skipped).toString());
      } else {
        this.titles = Array.from({ length: length }, (v, i) => i.toString());
      }
    }
  }

  getPercent(fix: number): number {
    return (fix * 100) / this.periodLength();
  }

  private buildOffsetSegments(): { left: number; width: number }[] {
    const periodLength = this.periodLength();
    const offset = this.offset();
    const end = offset + this.duration();
    if (!periodLength) return [];
    if (end > periodLength) {
      const wrappedEnd = end - periodLength;
      return [{ left: wrappedEnd, width: Math.max(0, offset - wrappedEnd) }];
    }
    return [
      { left: 0, width: Math.max(0, offset) },
      { left: end, width: Math.max(0, periodLength - end) },
    ];
  }

  getDateString(value: number): string {
    if (value === 0) return '00:00';
    const minutes = value % 60;
    const hours = (value - minutes) / 60;
    const hourString = hours < 10 ? `0${hours}` : hours;
    const minuteString = minutes < 10 ? `0${minutes}` : minutes;
    return `${hourString}:${minuteString}`;
  }

  getGeneralString(fix: number): string {
    if (this.periodLength() === 10080) {
      return moment(this.startDate())
        .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        .add({ minute: fix })
        .format('ddd HH:mm');
    } else {
      return this.getDateString(fix);
    }
  }

  isTransmitted(inSequenceCount: number, skipPosition = 0, fixPerTransmission = 1) {
    const cycleLength = (skipPosition || 0) + 1;
    const cycleIndex = Math.floor(inSequenceCount / cycleLength);
    return (
      (cycleIndex + 1) % (fixPerTransmission || 1) === 0 && inSequenceCount % cycleLength === 0
    );
  }
}
